import { configureStore } from '@reduxjs/toolkit';
import popupReducer from './popupSlice';
import popup2Reducer from './popup2Slice';
import formReducer from './formSlice';
import featureReducer from './featureSlice';

const store = configureStore({
  reducer: {
    popup: popupReducer,
    popup2: popup2Reducer, 
    form: formReducer,
    feature: featureReducer,
  },
  
   
 
});

export default store;